<form name="form" (ngSubmit)="f.form.valid && processData()" #f="ngForm" novalidate>
    <div class="row">
        <!--Catoger Type Selection-->
      <div class="col-md-6">
          <div class="form-group padding-right-10">
            <mat-form-field>
              <mat-select
                [disabled]="readonly"
                placeholder="Type"
                [(ngModel)]="catagoryData.type"
                name="type"
                #type="ngModel"
                (selectionChange)="onTypeChange($event)"
                required
              >
                <mat-option *ngFor="let type of typeList" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      </div>
      <!-- Category Selection -->
      <div class="col-md-6">
        <div class="form-group">
          <mat-form-field>
            <mat-select
            [disabled]="readonly"
              placeholder="Select"
              [(ngModel)]="catagoryData.title"
              name="title"
              #title="ngModel"
            >
              <mat-option *ngFor="let article of articleList" [value]="article?.id">
                {{ article?.title }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.submitted && title.invalid">Scheme is required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="form-group">
      <app-file-input *ngIf="!catagoryData?.thumbnailImage"
        (fileChange)="onFileChange($event)"
        [(ngModel)]="fileName"
        name="fileName"
        placeholder="Upload Image"
        required="true"
      >
        <button type="button" mat-raised-button color="primary">Choose</button>
      </app-file-input>
      <ng-template [ngIf]="catagoryData.thumbnailImage">
        <mat-form-field>
            <input
              disabled
              matInput
              placeholder="Image"
              [(ngModel)]="catagoryData.thumbnailImage"
              name="Image"
            />
            <button matSuffix mat-icon-button (click)="onClearThumbnail()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field> 
      </ng-template>
      <p>Note: Please upload image with resolution 220px × 200px</p>
    </div>
    <div class="margin-top-20 text-center">
      <button
        mat-raised-button
        color="primary"
        class="mat-button-large"
        type="submit"
        [disabled]="!f.valid && readonly"
      >
        Submit
      </button>
    </div>
</form>